import { render, staticRenderFns } from "./FamousCommentItemAllWeb.vue?vue&type=template&id=11c2d2e6&"
import script from "./FamousCommentItemAllWeb.vue?vue&type=script&lang=js&"
export * from "./FamousCommentItemAllWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports